module.exports = {
      id: "bed-usage",
      viewBox: "0 0 24 18",
      url: __webpack_public_path__ + "img/icons.bfe893b5.svg#bed-usage",
      toString: function () {
        return this.url;
      }
    }